<script setup>
import { ref } from 'vue';
import { PhxFocusSections, PhxFocusSectionsPoint, PhxFocusSectionsScroll } from '@phx-styleguides/jlc';

defineProps({
  title: {
    type: String,
    required: true,
  },
  preTitle: {
    type: String,
    required: true,
  },
  sections: {
    type: Array,
    required: true,
  },
});

const sectionsValue = ref([]);
</script>

<template>
  <phx-focus-sections v-model="sectionsValue" accordion-type="multiple" :title="title" :pretitle="preTitle">
    <template v-for="{ type, ...section } in sections" :key="section.id">
      <PhxFocusSectionsScroll v-if="type === 'scroll'" v-bind="section" :init-on-mounted="false" />
      <PhxFocusSectionsPoint v-else v-bind="section" />
    </template>
  </phx-focus-sections>
</template>
